import { Component, Prop, Vue, Watch, Ref } from 'vue-property-decorator'
import Topic from '@/diagrams/models/topic'
import CreateNodeEvent from '@/diagrams/events/create-node-event'
import biasOptions from '@/diagrams/utils/bias-options'
import Match from '@/diagrams/models/match'

@Component
export default class EditTopic extends Vue {

  @Prop({ default: null })
  private parentId!: null | string

  @Prop({ default: false })
  private editMode!: boolean

  @Prop({default: false})
  private archived!: boolean

  private biasOptions = biasOptions

  private createNode(evt: CreateNodeEvent): Topic {
    const model = new Topic()
    model.groupId = evt.parent.dbId
    return model
  }

  private selectNode(topic: Topic, match: Match): Topic {
    topic.name = match.name
    if (topic.keywords) {
      topic.keywords = match.keywords
    }
    return topic
  }
}
